import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import { Subscription } from 'rxjs';
import { UiService } from './../services/ui.service';
import { GridService } from './grid.service';
import { GridModel } from './model/grid-model';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CommonBindingDataService } from '../services/common-binding-data.service';
import { Table } from 'primeng/table';
import { LazyLoadEvent } from 'primeng/api';


@Component({
    selector: 'app-mi-grid-v2',
    providers: [GridService],
    templateUrl: './mi-grid-v2.component.html',
    standalone: false
})

export class MiGridV2Component implements OnInit, OnDestroy {
  subscription: Subscription;
  rowData: any[] = [];
  search = '';
  @Output() rowClickedEvent = new EventEmitter<any>();
  @Output() actionBtnClickedEvent = new EventEmitter<any>();
  @Output() totalRecordsEmitter = new EventEmitter<any>();
  @Output() getGridReference: EventEmitter<any> = new EventEmitter();
  @Input() url: any = '';
  @Input() bottomSearchBar: Boolean;
  @Input() isDetailScreen: Boolean;
  @Input() bottomExportButton: Boolean;
  @Input() rowSelection = 'single';
  @Input() printUrl: any = '';
  @Input() exportUrl: any = '';
  @Input() columnDefs: any[] = [];
  @Input() actionButtonsDefs: any[] = [];
  @Input() pagination: any = true;
  @Input() paginationPageSize: any = 15;
  @Input() paginationStartPage: any = 0;
  @Input() defaultSortField = '';
  @Input() divClass = '';
  @Input() actionButtonWidth = 150;
  @Input() inputPlaceholder = '';
  @Input() overlayLoadingTemplate: any = '<span class="ag-overlay-loading-center" "style=background:red">' +
    'Please wait while your rows are loading</span>';
  @ViewChild('dt', { static: true }) dt: Table;

  gridUrlParams = '';
  enableResize = 'false';
  displayRowView = false;
  rowSelectIndex = 0;
  datasource = [];
  model: GridModel;
  totalRecords = 0;

  setRowLength = 15;
  searchText = '';
  selectedRecords: any = [];

  constructor(
    private uiService: UiService,
    private gridService: GridService,
    private liveAnnouncer: LiveAnnouncer,
    private commonBindingDataService: CommonBindingDataService) { }

  ngOnInit() {
    this.dt.first = this.commonBindingDataService.queryUpdateObject.offset;
    this.dt.sortOrder = this.commonBindingDataService.queryUpdateObject.sortOrder;
    this.defaultSortField = this.commonBindingDataService.queryUpdateObject.sortField;
    this.subscription = this.uiService.sidebarToggledEvent
      .subscribe((state: string) => {
        this.refreshList();
      });
  }

  refreshList() {
    this.fetchAndLoadData();
  }

  fetchAndLoadData() {
    const that = this;
    if (that.url) {
      const filterUrl = that.getUrl(that.url);
      this.commonBindingDataService.searchUrl = that.url;
      this.gridService.loadGridData(filterUrl).subscribe(result => {
        this.rowSelectIndex = 0;
        const model = <GridModel>result;
        if (result !== undefined) {
          this.totalRecords = model.count;
          this.totalRecordsEmitter.emit(this.totalRecords);
          that.datasource = [];
          const data = model.data === null ? [] : model.data
          data.forEach(e => {
            that.columnDefs.forEach(c => {
              if (c && c.cellRenderer) {
                e[c.field] = c.cellRenderer(e);
              } else if (c && c.cellRendererHtml) {
                e[c.field] = c.cellRendererHtml(e);
              }
              that.actionButtonsDefs.forEach(d => {
                if (d.show) {
                  e[d.field] = d.show(e);
                }
                if (d.title) {
                  e[d.title] = d.title(e);
                }
                if (d.ariaLabel) {
                  e[d.ariaLabel] = d.ariaLabel(e);
                }
              });
            });
            that.datasource.push(e);
          });

          this.dt.first = this.commonBindingDataService.queryUpdateObject.offset;
          this.commonBindingDataService.queryUpdateObject.sortOrder = this.dt.sortOrder;
          if (this.commonBindingDataService.queryUpdateObject.offset !== 0) {
            document.getElementById('searchId').focus();
          }

          const paginatorFirst = document.getElementsByClassName('ui-paginator-first');
          paginatorFirst[0]?.setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_first'));

          const paginatorPrevious = document.getElementsByClassName('ui-paginator-prev');
          paginatorPrevious[0]?.setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_previous'));

          const paginatorNext = document.getElementsByClassName('ui-paginator-next');
          paginatorNext[0]?.setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_next'));

          const paginatorLast = document.getElementsByClassName('ui-paginator-last');
          paginatorLast[0]?.setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_last'));

          const paginatorPageLinks = document.getElementsByClassName('ui-paginator-page');
          for (let index = 0; index < paginatorPageLinks.length; index++) {
            paginatorPageLinks[index].setAttribute('aria-label', 'Page ' + paginatorPageLinks[index].textContent);
          }

        }
      });
    }
  }

  getUrl(url) {
    this.search = this.commonBindingDataService.searchUpdateObject.searchText;
    let params = 'searchText=' + this.commonBindingDataService.searchUpdateObject.searchText +
      '&offset=' + this.commonBindingDataService.queryUpdateObject.offset + '&limit=' + this.setRowLength;

    params += '&sortColumn=';
    params += this.commonBindingDataService.queryUpdateObject.sortField;
    params += '&sortType=';
    params += this.commonBindingDataService.queryUpdateObject.sortOrderString;
    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }
    if (this.url.lastIndexOf('?') < 0) {
      this.gridUrlParams = '';
    } else {
      this.gridUrlParams = this.url.substring(this.url.lastIndexOf('?'));
      this.gridUrlParams = this.gridUrlParams.replace('?', '&');
    }
    buildUrl += params;

    return buildUrl;
  }

  getUrlExport(url) {
    const that = this;
    let params = 'searchText=' + this.search;

    params += '&sortColumn=';
    params += this.commonBindingDataService.queryUpdateObject.sortField;
    params += '&sortType=';
    params += this.commonBindingDataService.queryUpdateObject.sortOrderString;
    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }
    if (this.url.lastIndexOf('?') < 0) {
      this.gridUrlParams = '';
    } else {
      this.gridUrlParams = this.url.substring(this.url.lastIndexOf('?'));
      this.gridUrlParams = this.gridUrlParams.replace('?', '&');
    }
    buildUrl += params;

    return buildUrl;
  }

  public onQuickFilterChanged($event) {
    if ($event.key === 'Enter') {
      this.commonBindingDataService.queryUpdateObject = JSON.parse(JSON.stringify(this.commonBindingDataService.queryDefaultObject));
      this.commonBindingDataService.searchUpdateObject = JSON.parse(JSON.stringify(this.commonBindingDataService.searchDefaultObject));
      this.commonBindingDataService.searchUpdateObject.searchText = this.search;
      this.applySearch();
      this.dt.first = 0;
    }

    if (($event.key === 'Backspace' || $event.key === 'Delete') && this.search.trim() === '') {
      this.commonBindingDataService.queryUpdateObject = JSON.parse(JSON.stringify(this.commonBindingDataService.queryDefaultObject));
      this.commonBindingDataService.searchUpdateObject = JSON.parse(JSON.stringify(this.commonBindingDataService.searchDefaultObject));
      this.applySearch();
    }
  }

  updateUrl(url: string) {
    this.url = url;
    this.dt.first = this.commonBindingDataService.queryUpdateObject.offset;
    this.refreshList();
  }

  loadDatasourceLazy(event: LazyLoadEvent) {
    if (event.sortField !== undefined) {
      const headerName: any = this.columnDefs.filter(item => item.field === event.sortField)
      if (event.sortOrder === 1) {
        this.liveAnnouncer.announce(this.commonBindingDataService.getLabel(`aria_label_table_header_announce_sort_asc`) +
          headerName[0].header)
      } else {
        this.liveAnnouncer.announce(this.commonBindingDataService.getLabel(`aria_label_table_header_announce_sort_desc`) +
          headerName[0].header)
      }
    }

    this.commonBindingDataService.queryUpdateObject.sortField = this.defaultSortField;
    this.commonBindingDataService.queryUpdateObject.offset = (event.first === undefined ?
      (this.dt.first === undefined ? 0 : this.dt.first) : event.first);
    this.setRowLength = event.rows;
    if (event.sortField !== undefined) {
      this.commonBindingDataService.queryUpdateObject.sortField = event.sortField;
    }
    this.commonBindingDataService.queryUpdateObject.sortOrderString = event.sortOrder > 0 ? 'asc' : 'desc';
    this.fetchAndLoadData();
  }

  onRowSelect(event) {
    // this.rowClickedEvent.emit(this.selectedRecords);
    this.rowSelectIndex = event.index % this.paginationPageSize;
    this.displayRowView = true;
    // this.rowClickedEvent.emit(event);
  }

  onRowUnselect(event) {
    // console.log(event);
    // console.log(this.selectedRecords);
  }

  actionBtnClick(event, data: any, action: string) {
    event.stopPropagation();
    const obj = { row: data, class: action };
    this.displayRowView = false;
    this.actionBtnClickedEvent.emit(obj);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSelectedRecords() {
    return this.selectedRecords;
  }

  applySearch() {
    this.commonBindingDataService.queryUpdateObject.offset = 0;
    this.fetchAndLoadData();
  }

  exportGridExcel(event: any) {
    const that = this;
    this.gridService.downloadExcelGridData(that.getUrlExport(that.exportUrl) + this.gridUrlParams);
  }

  exportGridPdf(event: any) {
    const that = this;
    this.gridService.downloadPdfGridData(that.getUrlExport(that.printUrl) + this.gridUrlParams);
  }

  onResetSearchInput() {
    if (this.search) {
      this.search = this.searchText = '';
      this.commonBindingDataService.searchUpdateObject.searchText = '';
      this.refreshList();
    }
  }
}
